var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: "Dias restantes para ejecutar una acción comercial",
          expression: "'Dias restantes para ejecutar una acción comercial'"
        }
      ]
    },
    [
      _vm.doc.plazo <= 0
        ? _c("div", [_c("span", [_vm._v("Vencido")])])
        : _c("div", [_vm._v(" " + _vm._s(_vm.doc.plazo) + " ")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }